import { render, staticRenderFns } from "./ItemBase.vue?vue&type=template&id=42e3e00f&scoped=true&"
import script from "./ItemBase.vue?vue&type=script&lang=js&"
export * from "./ItemBase.vue?vue&type=script&lang=js&"
import style0 from "./ItemBase.vue?vue&type=style&index=0&id=42e3e00f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e3e00f",
  null
  
)

export default component.exports